function getConfigCompoment () { return 'ExtConfigCompoment' }
function getStandardAttributes () { return null }

export default {
  hasSync: false,
  hasExecutions: true,
  hasItemSync: false,
  canManageAttributes: false,
  getConfigCompoment,
  getStandardAttributes
}
